import React from 'react'
import { FcGoogle } from "react-icons/fc";
import { FaRankingStar } from "react-icons/fa6";

import { FaStar } from "react-icons/fa";
import { MdStars } from "react-icons/md";


function Branding() {
  return (
    <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex justify-center gap-10 xl:my-24 items-center  lg:border-y">       
    <div className='flex flex-col lg:py-10 gap-5 w-full items-center  xl:w-[70%]'>
        <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] text-center  '> Most trusted reputation and customer experience platform for brands & local businesses</span>
        <span className=' text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] text-center  xl:w-[60%]'>Our tool's performance is reflected in its high ratings Google, where it has received praise from satisfied customers.</span>
        <div className='flex gap-2 '>
        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                            <div className=''>
                                <span className='text-sm bold'>Google </span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
        </div>
    </div>
  )
}

export default Branding
